import React, { VFC } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { BlockProps, QuadContainerJson } from '/types';

import style from './BlockQuadrant.scss';
import QuadrantCell from './QuadrantCell';

const BlockQuadrant: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  blockContent,
  presentOption,
  ...props
}) => {
  setAnimationComplete(animationStep >= 4);

  return (
    <ArticleBlock
      {...props}
      hideFooter={animationEnabled && animationStep < 4}
      blockContent={blockContent}
      titleCentered
      columns={[
        <div key="grid" className={style.grid}>
          {(blockContent.columns?.list || []).map((cell, i) => (
            <QuadrantCell
              cell={(cell as QuadContainerJson).elements}
              presentOption={presentOption}
              index={i}
              animationStep={animationStep}
              animationEnabled={animationEnabled}
              key={i}
            />
          ))}
        </div>,
      ]}
    />
  );
};

BlockQuadrant.displayName = 'BlockQuadrant';
export default BlockQuadrant;
